import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CompetenciaGestionPayload {
  id_competencia: string;
  id_cargo: number;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface CompetenciaGestion {
  id?: number;
  id_competencia: string;
  id_cargo: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface CompetenciaGestionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CompetenciaGestionService {
  private readonly apiUrl = `${environment.apiUrl}/api/competencia_gestion`;

  constructor(private http: HttpClient) {}

  // Listar todas las relaciones competencia-cargo
  getAll(): Observable<CompetenciaGestion[]> {
    return this.http.get<CompetenciaGestion[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<CompetenciaGestion> {
    return this.http.get<CompetenciaGestion>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nueva relación
  create(payload: CompetenciaGestionPayload): Observable<CompetenciaGestionResponse> {
    return this.http.post<CompetenciaGestionResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar relación
  update(id: number, payload: Partial<CompetenciaGestionPayload>): Observable<CompetenciaGestionResponse> {
    return this.http.put<CompetenciaGestionResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar relación (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar relación
  inactivar(id: number): Observable<CompetenciaGestionResponse> {
    return this.http.put<CompetenciaGestionResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar relación
  activar(id: number): Observable<CompetenciaGestionResponse> {
    return this.http.put<CompetenciaGestionResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}
